import React from 'react'
import '../../App.css';
import OtherUserProfile from '../OtherUserProfile';

function Likes() {
  return (
    <>
        <br/><br/><br/>
        <div className='container'>
            <div className='signup-container'>
                <h3 className='subheader green-text'>Likes</h3>
                <p className='maintext signup-sub'>View profiles to match to rent together</p>
            </div>
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
            <OtherUserProfile />
        </div>
        
    </>
  );
}

export default Likes